import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import NumeralService from '@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '@/modules/core/app/constants/data.constants';

export class AnimatedTaxAmount extends BaseModel {
  estimatedAmount?: number;
  target?: number;

  constructor(model: Partial<AnimatedTaxAmount> = {}) {
    super();

    this.estimatedAmount = model.estimatedAmount ?? 0;
    this.target = model.target ?? 0;
  }

  get formattedAmount(): string {
    return NumeralService.formatValue(this.estimatedAmount, ColumnFormat.FORMAT_CURRENCY);
  }
}
